<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>
        <action-button type="default" text="" icon="content_copy" :icon_only="true" v-if="coursetemplate.id" @click="duplicate" small />

        <v-spacer></v-spacer>

        <v-layout row wrap>
          <v-flex xs12 class="text-right pr-2">
            <action-button type="back" @click="$router.go(-1)" />

            <action-button type="save" @click="save" />

            <action-button type="view" @click="preview" :text="$t('global.preview')" v-if="coursetemplate.id" />

            <action-button type="delete" @click="del(coursetemplate.id)" v-if="allow_delete && coursetemplate.id" />
          </v-flex>
        </v-layout>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  name="coursetemplate.name"
                  v-model="coursetemplate.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('coursetemplates.name')"
                  :error-messages="errors.collect('coursetemplate.name')"
                  :readonly="!allow_edit"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  name="coursetemplate.internal_comment"
                  v-model="coursetemplate.internal_comment"
                  v-validate="'max:255'"
                  :label="$t('coursetemplates.internal_comment')"
                  :error-messages="errors.collect('coursetemplate.internal_comment')"
                  :readonly="!allow_edit"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  name="coursetemplate.certificate_display_name"
                  v-model="coursetemplate.certificate_display_name"
                  :label="$t('coursetemplates.certificate_display_name')"
                  :error-messages="errors.collect('coursetemplate.certificate_display_name')"
                  :readonly="!allow_edit"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="coursetemplate.short_description"
                  v-model="coursetemplate.short_description"
                  rows="3"
                  auto-grow
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('coursetemplates.short_description')"
                  :error-messages="errors.collect('coursetemplate.short_description')"
                  :readonly="!allow_edit"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="coursetemplate.long_description"
                  v-model="coursetemplate.long_description"
                  rows="3"
                  auto-grow
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('coursetemplates.long_description')"
                  :error-messages="errors.collect('coursetemplate.long_description')"
                  :readonly="!allow_edit"
                ></v-textarea>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-tooltip v-model="showInfoLinkCopiedToolTip" bottom color="primary" nudge-bottom="-20">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      name="coursetemplate.info_link"
                      v-model="coursetemplate.info_link"
                      v-validate="'max:255|url'"
                      :label="$t('coursetemplates.info_link')"
                      :error-messages="errors.collect('coursetemplate.info_link')"
                      :readonly="!allow_edit"
                      autocomplete="new-password"
                      prepend-icon="link"
                      append-outer-icon="open_in_new"
                      @click:append-outer="redirectToInfoLink"
                      @click="copyInfoLink"
                    ></v-text-field>
                  </template>
                  <span>{{ $t("global.copied") }}</span>
                </v-tooltip>
                <input class="d-none" type="text" :value="coursetemplate.info_link" id="copy-info-link" />
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="coursetemplate.coursetypegroup_id"
                  ref="coursetypegroup_id"
                  v-model="coursetemplate.coursetypegroup_id"
                  class="required-field"
                  v-validate="'required'"
                  @change="courseGroupChange(coursetemplate.coursetypegroup_id)"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('coursetemplate.coursetypegroup_id')"
                  :readonly="!allow_edit"
                  :clearable="allow_edit"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="coursetemplate.coursetype_id"
                  v-model="selectedCourseTypes"
                  class="required-field"
                  v-validate="'required'"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('coursetemplate.coursetype_id')"
                  :readonly="!allow_edit"
                  :clearable="allow_edit"
                  multiple
                ></v-autocomplete>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-autocomplete
                                    name="coursetemplate.moduletemplate_id"
                                    v-model="selectedModuleTemplates"
                                    class="required-field" v-validate="'required'"
                                    :items="moduletemplates"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('moduletemplates.title')"
                                    autocomplete="new-password"
                                    :error-messages="errors.collect('coursetemplate.moduletemplate_id')"
                                    :readonly="!(allow_edit)"
                                    :clearable="(allow_edit)"
                                    multiple
                                ></v-autocomplete>
                            </v-flex>-->
              <v-flex lg2 md4 sm6 xs12 class="d-none">
                <v-select
                  name="coursetemplate.coursetemplatetype_id"
                  v-model="coursetemplate.coursetemplatetype_id"
                  item-text="text"
                  item-value="key"
                  :items="dd_course_templates_type"
                  :label="$t('coursetemplates.coursetemplatetype_id')"
                  :error-messages="errors.collect('coursetemplate.coursetemplatetype_id')"
                  :readonly="!allow_edit"
                  :clearable="allow_edit"
                ></v-select>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="coursetemplate.number_of_days"
                  v-validate="'numeric'"
                  v-model="coursetemplate.number_of_days"
                  :label="$t('coursetemplates.number_of_days')"
                  :error-messages="errors.collect('coursetemplate.number_of_days')"
                  :readonly="!allow_edit"
                  @keypress="$keyDown_IntOnly($event)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md2 sm6 xs6 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="course.num_places"
                  v-validate="'numeric'"
                  v-model="coursetemplate.num_places"
                  :label="$t('courses.num_places')"
                  :error-messages="errors.collect('course.num_places')"
                  :readonly="!allow_edit"
                  @keypress="$keyDown_IntOnly($event)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md2 sm6 xs6 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="course.enrolment_due_in_days"
                  v-validate="'numeric'"
                  v-model="coursetemplate.enrolment_due_in_days"
                  :label="$t('coursetemplates.enrolment_due_in_days')"
                  :error-messages="errors.collect('coursetemplates.enrolment_due_in_days')"
                  :readonly="!allow_edit"
                  @keypress="$keyDown_IntOnly($event)"
                  autocomplete="new-password"
                >
                  <help-text slot="append" :tooltip="$t('coursetemplates.enrolment_due_in_days_helptext')" />
                </v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-select
                  name="coursetemplate.status"
                  v-model="coursetemplate.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_templates_status()"
                  :label="$t('coursetemplates.status')"
                  :error-messages="errors.collect('coursetemplate.status')"
                  :readonly="!allow_edit"
                  :clearable="allow_edit"
                ></v-select>
              </v-flex>
              <v-flex lg1 md3 sm3 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="coursetemplate.valid_for"
                  v-model="coursetemplate.valid_for"
                  v-validate="'numeric'"
                  :label="$t('coursetemplates.valid_for')"
                  :error-messages="errors.collect('coursetemplate.valid_for')"
                  :suffix="$t('coursetemplates.months')"
                  autocomplete="new-password"
                >
                  <help-text slot="append" :tooltip="$t('coursetemplates.valid_for_helptext')" />
                </v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="coursetemplate.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('coursetemplates.price')"
                  :error-messages="errors.collect('coursetemplate.price')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg1 md4 sm6 xs12 v-if="coursetemplate.type == 1">
                                <v-text-field
                                    name="coursetemplate.price_proof"
                                    v-model="computedPriceProof"
                                    @keypress="$keyDown_PriceOnly($event)"
                                    :hint="'Format:' + PRICE_FORMAT"
                                    :label="$t('coursetemplates.price_proof')"
                                    :error-messages="errors.collect('coursetemplate.price_proof')"
                                    :readonly="!allow_edit"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>
                            <v-flex lg1 md4 sm6 xs12 v-if="coursetemplate.type == 1">
                                <v-text-field
                                    name="coursetemplate.price_vat"
                                    v-model="computedPriceVat"
                                    @keypress="$keyDown_PriceOnly($event)"
                                    :hint="'Format:' + PRICE_FORMAT"
                                    :label="$t('coursetemplates.price_vat')"
                                    :error-messages="errors.collect('coursetemplate.price_vat')"
                                    :readonly="!allow_edit"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->

              <v-flex lg2 md3 sm6 xs12>
                <v-checkbox
                  v-model="coursetemplate.send_email_notification"
                  :label="$t('coursetemplates.send_email_notification')"
                  :readonly="!allow_edit"
                ></v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-checkbox
                  v-model="coursetemplate.send_sms_notification"
                  :label="$t('coursetemplates.send_sms_notification')"
                  :disabled="!allow_edit || !Boolean(organisation.sms_service)"
                ></v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="integration_klarna">
                <v-checkbox v-model="coursetemplate.klarna_checkout" :label="$t('coursetemplates.klarna_checkout')" :disabled="!allow_edit">
                  <help-text slot="append" :tooltip="$t('coursetemplates.klarna_checkout_type_helptext')" />
                </v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="integration_klarna && coursetemplate.klarna_checkout">
                <v-select
                  name="coursetemplate.klarna_checkout.type"
                  v-model="coursetemplate.klarna_checkout_type"
                  item-text="text"
                  item-value="key"
                  :items="$dd_klarna_checkout_type()"
                  :label="$t('coursetemplates.klarna_checkout_type')"
                  :disabled="!allow_edit"
                ></v-select>
              </v-flex>
              <v-flex xs12></v-flex>
              <v-flex xs6>
                <p class="text-left mb-0" v-if="coursetemplate.admin_id">
                  {{
                    $t("coursetemplates.copied_from_admin", {
                      name: coursetemplate.created_by_name,
                      datetime: moment.utc(coursetemplate.created_at).format(DATE_FORMAT + " " + TIME_FORMAT)
                    })
                  }}
                </p>
                <p class="text-left mb-0" v-if="coursetemplate.admin_id">
                  {{
                    $t("coursetemplates.admin_template_from", {
                      datetime: moment.utc(coursetemplate.admin_updated_at).format(DATE_FORMAT + " " + TIME_FORMAT)
                    })
                  }}
                </p>
              </v-flex>
              <v-flex xs6>
                <p class="text-right mb-0" v-if="coursetemplate.updated_by != null">
                  {{
                    $t("global.last_updated_by") +
                    (coursetemplate.updated_by == -1 ? $t("global.xl3_admin") : coursetemplate.updated_by_name)
                  }}
                  {{ moment.utc(coursetemplate.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("coursetemplates.pdf_template") }}</v-toolbar-title>
          </v-app-bar>

          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 lg5>
                <v-text-field
                  name="coursetemplate.pdf_title"
                  v-model="coursetemplate.pdf_title"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('coursetemplates.pdf_title')"
                  :error-messages="errors.collect('coursetemplate.pdf_title')"
                  :readonly="!allow_edit"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg7>
                <v-text-field
                  name="coursetemplate.pdf_description"
                  v-model="coursetemplate.pdf_description"
                  :label="$t('coursetemplates.pdf_description')"
                  :error-messages="errors.collect('coursetemplate.pdf_description')"
                  :readonly="!allow_edit"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 lg5>
                      <v-flex xs12>
                        <v-text-field
                          name="organisations.tenant_company"
                          :value="tenant_company"
                          :label="$t('organisations.tenant_company')"
                          :readonly="true"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <action-button
                          type="new"
                          :text="$t('coursetemplates.upload_pdf_template')"
                          @click="showUploadTemplate"
                          class="ml-0 mb-5"
                        />

                        <div v-if="coursetemplate.id && coursetemplate.original_filename">
                          <p>
                            {{ coursetemplate.original_filename }}

                            <action-button
                              type="download"
                              small
                              class="text-right"
                              :icon_only="true"
                              @click="downloadTemplate(coursetemplate.filename, coursetemplate.original_filename)"
                            />
                            <action-button
                              type="delete"
                              small
                              class="text-right"
                              :icon_only="true"
                              @click="deleteTemplate(coursetemplate.id)"
                            />
                          </p>

                          <action-button
                            type="view"
                            :text="$t('coursetemplates.preview_pdf_template')"
                            @click="previewTemplate(coursetemplate.id)"
                            class="ml-0 mt-2"
                          />
                        </div>

                        <div v-if="!coursetemplate.id && pdfTemplateFile">
                          <p>
                            {{ pdfTemplateFile.name }}
                            <action-button type="delete" small class="text-right" :icon_only="true" @click="cancelUploadTemplate()" />
                          </p>
                        </div>
                      </v-flex>
                    </v-flex>
                    <v-flex xs12 lg7>
                      <v-flex xs12>
                        <!--<quill-editor
                                                        name="coursetemplate.pdf_content"
                                                        v-model="coursetemplate.pdf_content"
                                                        :options="editorOption"
                                                        :label="$t('coursetemplates.pdf_content')"
                                                        :error-messages="errors.collect('coursetemplate.pdf_content')"
                                                        :readonly="!allow_edit"
                                                    ></quill-editor>-->
                        <v-textarea
                          name="coursetemplate.pdf_content"
                          v-model="coursetemplate.pdf_content"
                          rows="3"
                          auto-grow
                          :label="$t('coursetemplates.pdf_content')"
                          :error-messages="errors.collect('coursetemplate.pdf_content')"
                          :readonly="!allow_edit"
                        ></v-textarea>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels :value="1" class="cstm-filter mt-4 elevation-0" v-if="coursetemplate.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              {{ $t("moduletemplates.title") }}

              <v-spacer></v-spacer>

              <v-flex xs2>
                <v-btn class="d-flex-inherit cstm-v-btn darken-2 float-right" color="success" @click.stop="modtemplistpopup_show" small>
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                </v-btn>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <draggable v-model="cmDragged" handle=".drag-icon" class="full-width-draggable">
                  <v-flex xs12 v-for="moduletemplate in coursetemplate_moduletemplates" :key="moduletemplate.id">
                    <v-card>
                      <v-card-title class="body-1 mt-card-title">
                        <div class="body-2">
                          <v-icon class="drag-icon mr-2" dark small>fas fa-grip-vertical</v-icon>
                          {{ moduletemplate.name }}
                        </div>
                        <div class="caption ml-2" v-if="!moduletemplate.is_included">
                          ({{ $t("moduletemplates.price") }}: {{ moduletemplate.price }})
                        </div>
                        <v-spacer></v-spacer>

                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.hide_in_accomplishment"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.hide_in_accomplishment") }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.hide_in_enrolment"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.hide_in_enrolment") }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.select_visibility"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $dd_select_visibility(moduletemplate.select_visibility) }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.is_included"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.is_included") }}</v-chip
                        >
                        <action-button
                          type="edit"
                          @click="editModuleTemplate(moduletemplate.id)"
                          :icon_only="true"
                          small
                          v-if="$can('coursetemplate-delete')"
                        />
                        <action-button
                          type="delete"
                          @click="delModuleTemplate(coursetemplate.id, moduletemplate.id)"
                          :icon_only="true"
                          small
                          v-if="$can('coursetemplate-delete')"
                        />
                      </v-card-title>
                      <v-card-text v-if="moduletemplate.module_options && moduletemplate.module_options.length > 0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left" width="20%">{{ $t("moduleoptions.name") }}</th>
                                <th class="text-left" width="10%">{{ $t("moduleoptions.price") }}</th>
                                <th class="text-left" width="10%">{{ $t("moduleoptions.hours") }}</th>
                                <th class="text-left" width="10%">
                                  {{ $t("moduleoptions.enrol_select") }}
                                </th>
                                <th class="text-left" width="10%">
                                  {{ $t("moduleoptions.mandatory_accomplishment") }}
                                </th>
                                <th class="text-left" width="10%">
                                  {{ $t("global.dd_select_visibility_expertise") }}
                                </th>
                                <th class="text-left" width="10%">
                                  {{ $t("global.dd_select_visibility_course_certificate") }}
                                </th>
                                <th class="text-end" width="12%">{{ $t("global.actions") }}</th>
                              </tr>
                            </thead>
                            <tbody v-for="moduleoption in moduletemplate.module_options" :key="moduleoption.id">
                              <tr>
                                <td scope="row" :class="moduleoption.comment ? 'py-2' : ''">
                                  {{ moduleoption.name }}
                                  <p v-if="moduleoption.comment" class="font-italic mb-0">( {{ moduleoption.comment }} )</p>
                                </td>
                                <td scope="row">{{ moduleoption.price }}</td>
                                <td scope="row">{{ moduleoption.hours }}</td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.enrol_select)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.mandatory_accomplishment)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.add_to_expertise)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.add_to_course_certificate)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td class="text-end" scope="row">
                                  <action-button
                                    type="new"
                                    small
                                    @click="showForm(null, 'moduleoptioncoursetype', moduleoption.id)"
                                    :icon_only="true"
                                  />

                                  <action-button
                                    type="edit"
                                    :icon_only="true"
                                    small
                                    @click="showForm(moduleoption.id, 'moduleoption', moduletemplate.id)"
                                  />
                                  <action-button
                                    type="delete"
                                    :icon_only="true"
                                    small
                                    @click="del_option(moduleoption.id)"
                                    v-if="moduleoption.admin_id == null"
                                  />
                                </td>
                              </tr>
                              <tr v-if="moduleoption.module_options_course_types && moduleoption.module_options_course_types.length > 0">
                                <td :colspan="8" class="ct-td">
                                  <v-card>
                                    <v-app-bar flat dense color="white">
                                      <v-toolbar-title class="body-2">{{ $t("coursetypes.title") }}</v-toolbar-title>
                                    </v-app-bar>
                                    <v-card-text class="pa-4">
                                      <v-simple-table>
                                        <template v-slot:default>
                                          <thead>
                                            <tr>
                                              <!--<th class="text-left">{{ $t('moduleoptioncoursetypes.coursetype_id') }}</th>-->
                                              <th class="text-left">
                                                {{ $t("moduleoptioncoursetypes.name") }}
                                              </th>
                                              <th class="text-left">
                                                {{ $t("moduleoptioncoursetypes.price") }}
                                              </th>
                                              <th class="text-end" width="20%">
                                                {{ $t("global.actions") }}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="coursetype in moduleoption.module_options_course_types">
                                              <tr :key="coursetype.id + '-td1'" :class="coursetype.comment ? 'tr-no-bottom-border' : ''">
                                                <!--<td scope="row">{{ coursetype.coursetype.category }}</td>-->
                                                <td scope="row">{{ coursetype.name }}</td>
                                                <td scope="row">{{ coursetype.price }}</td>
                                                <td scope="row" class="text-end">
                                                  <action-button
                                                    type="edit"
                                                    :icon_only="true"
                                                    small
                                                    @click="
                                                      showForm(
                                                        coursetype.id,
                                                        'moduleoptioncoursetype',
                                                        moduleoption.id,
                                                      )
                                                    "
                                                  />
                                                  <action-button
                                                    type="delete"
                                                    :icon_only="true"
                                                    small
                                                    @click="del_option_ct(coursetype.id)"
                                                  />
                                                </td>
                                              </tr>
                                              <tr :key="coursetype.id + '-td2'" v-if="coursetype.comment">
                                                <td colspan="4">
                                                  <span> {{ $t("moduleoptioncoursetypes.comment") }}: {{ coursetype.comment }} </span>
                                                </td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                    </v-card-text>
                                  </v-card>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </draggable>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="mt-4" v-if="coursetemplate.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("notificationtemplates.title") }}</v-toolbar-title>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text>
            <v-flex md12>
              <v-data-table
                :headers="ent_headers"
                :items="notificationtemplates"
                :items-per-page="notificationtemplates.length"
                :options.sync="ent_pagination"
                :footer-props="{
                  showFirstLastPage: true,
                  'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                  'items-per-page-all-text': $t('global.items_per_page_all_text'),
                  'items-per-page-text': $t('global.items_per_page_text'),
                  'page-text': $t('global.page_text')
                }"
                :server-items-length="ent_total"
                :loading="ent_show_loading"
                :loading-text="$t('global.loading_text')"
                :no-data-text="$t('global.no_data_text')"
                :no-results-text="$t('global.no_results_text')"
                :must-sort="true"
              >
                <template v-slot:item.updated_at="{ item }">
                  {{ item.updated_at ? moment.utc(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <router-link
                    :to="{
                      path: BACKEND_URL + '/notificationtemplates/edit/' + item.id + '?from_module=' + currentFromModule,
                      params: { id: item.id }
                    }"
                    v-if="$can('coursetemplate-edit')"
                  >
                    <action-button type="edit" :icon_only="true" small />
                  </router-link>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>

    <v-dialog v-model="showUploadTemplateForm" persistent max-width="960px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-app-bar flat dense color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("coursetemplates.upload_pdf_template") }}</v-toolbar-title>
                </v-app-bar>

                <v-card-text class="pa-4">
                  <ValidationObserver ref="pdfTemplateFile">
                    <v-flex xs12>
                      <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                        <v-file-input
                          v-model="pdfTemplateFile"
                          accept=".pdf"
                          color="primary"
                          counter
                          :placeholder="$t('coursetemplates.select_pdf_template')"
                          prepend-icon="attach_file"
                          outlined
                          :show-size="1000"
                          clearable
                          :error="errors.length > 0"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:selection="{ index, text }">
                            <v-chip color="primary" dark label small>
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </ValidationProvider>
                    </v-flex>
                  </ValidationObserver>
                  <v-flex xs12>
                    <v-card
                      @drop.prevent="documentOnDrop($event)"
                      @dragover.prevent="document_dragover = true"
                      @dragenter.prevent="document_dragover = true"
                      @dragleave.prevent="document_dragover = false"
                      :class="{ 'grey lighten-2': document_dragover }"
                    >
                      <v-card-text>
                        <v-row class="d-flex flex-column" dense align="center" justify="center">
                          <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                          <p>{{ $t("global.drop_files_here") }}</p>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />

                  <action-button type="cancel" @click="cancelUploadTemplate" />
                  <action-button type="upload" @click="uploadTemplate()" :disabled="!pdfTemplateFile" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>

    <v-dialog v-model="showTypeForm" persistent max-width="500px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-card>
            <v-card-text class="pa-4">
              <p>{{ $t("coursetemplates.select_template_type") }}</p>
              <action-button
                type="default"
                :text="$t('global.dd_course_templates_type_normal')"
                class="d-block ml-0"
                @click="selectTemplateType(1)"
              />
              <p class="mt-1">{{ $t("coursetemplates.type_normal_helptext") }}</p>
              <action-button
                type="default"
                :text="$t('global.dd_course_templates_type_long')"
                class="d-block ml-0"
                @click="selectTemplateType(2)"
              />
              <p class="mt-1">{{ $t("coursetemplates.type_long_helptext") }}</p>
              <action-button type="cancel" color="error" :icon="null" class="d-block ml-0" @click="cancelTypeSelection" />
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </v-dialog>

    <moduleTemplateListPopup
      :show="showModuleTemplateListPopup"
      :except_ids="selectedModuleTemplates"
      @callback_modtemplistpopup_cancel="callback_modtemplistpopup_cancel"
      @callback_modtemplistpopup_submit="callback_modtemplistpopup_submit"
    />

    <CourseTemplateListPopup
      :show="showCourseTemplateListPopup"
      :show_select="false"
      :moduletemplate_id="selectedModuleTemplate"
      :title="$t('coursetemplates.module_template_used_multiple')"
      @callback_coursetemplistpopup_cancel="callback_coursetemplistpopup_cancel"
      @callback_coursetemplistpopup_submit="callback_coursetemplistpopup_submit"
      mode="coursetemplate-moduletemplate-edit"
    />

    <v-dialog v-model="showDialogForm" persistent max-width="75%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          :moduletemplate_id="currentLoadedForm.moduletemplate_id"
          :moduleoption_id="currentLoadedForm.moduleoption_id"
          :course_type="coursetemplate ? coursetemplate.type : null"
          :from_module="currentFromModule"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"
import draggable from "vuedraggable"
import moduleTemplateListPopup from "../../moduletemplates/partials/ModuleTemplateListPopup.vue"
import CourseTemplateListPopup from "../../coursetemplates/partials/CourseTemplateListPopup.vue"

export default {
  name: "CourseTypesForm",

  props: ["id"],

  components: {
    ValidationObserver,
    ValidationProvider,
    draggable,
    moduleTemplateListPopup,
    CourseTemplateListPopup,
    quillEditor,
    "moduletemplate-form": () => import("../../moduletemplates/components/Form"),
    "moduleoption-form": () => import("../../moduleoptions/components/Form"),
    "moduleoptioncoursetype-form": () => import("../../moduleoptioncoursetypes/components/Form"),
  },

  data() {
    return {
      allow_edit: false,
      allow_delete: false,
      dd_course_templates_type: this.$dd_course_templates_type(),

      page_title: "",
      predata: {},
      coursetemplate: {
        has_locale: false
      },
      coursetemplate_moduletemplates: [],

      organisation: {},

      coursetypes: [],
      moduletemplates: [],
      coursetypegroups: [],

      selectedCourseTypes: [],
      selectedModuleTemplates: [],
      selectedModuleTemplate: null,

      showModuleTemplateListPopup: false,
      showTypeForm: false,
      showCourseTemplateListPopup: false,

      notificationtemplates: [],
      ent_total: 0,
      ent_show_loading: false,
      ent_show_filter: false,
      ent_refresh: false,
      ent_pagination: {
        page: this.$getLocalStorage("__ctEnrolmentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      showUploadTemplateForm: false,
      pdfTemplateFile: null,
      document_dragover: false,

      editorOption: {
        modules: {
          toolbar: [[{ header: [1, 2, 3, 4, 5, 6, false] }], ["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }]]
        }
      },

      currentFormId: null,
      currentModuleTemplateId: null,
      currentModuleOptionId: null,
      currentForm: null,
      currentFromModule: "coursetemplate",
      showDialogForm: false,

      showInfoLinkCopiedToolTip: false,

      integrations: [],
      integration_p360: null,
      integration_klarna: null,

      dictionary: {
        attributes: {
          "coursetemplate.name": this.$t("coursetemplates.name"),
          "coursetemplate.short_description": this.$t("coursetemplates.short_description"),
          "coursetemplate.long_description": this.$t("coursetemplates.long_description"),
          "coursetemplate.coursetemplatetype_id": this.$t("coursetemplates.coursetemplatetype_id"),
          "coursetemplate.pdf_title": this.$t("coursetemplates.pdf_title"),
          "coursetemplate.pdf_description": this.$t("coursetemplates.pdf_description"),
          "coursetemplate.pdf_content": this.$t("coursetemplates.pdf_content"),
          "coursetemplate.info_link": this.$t("coursetemplates.info_link"),
          "coursetemplate.coursetype_id": this.$t("coursetypes.title"),
          "coursetemplate.moduletemplate_id": this.$t("moduletemplates.title"),
          "coursetemplate.price": this.$t("coursetemplates.price"),
          "coursetemplate.price_proof": this.$t("coursetemplates.price_proof"),
          "coursetemplate.price_vat": this.$t("coursetemplates.price_vat"),
          "coursetemplate.status": this.$t("coursetemplates.status"),
          "coursetemplate.certificate_display_name": this.$t("coursetemplates.certificate_display_name")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.coursetemplate, this.predata, this.save, this.isFormValid)
    })
  },

  watch: {
    ent_refresh: {
      handler() {
        if (this.ent_refresh && this.coursetemplate.id) {
          this.notificationtemplate_list()
        }
      }
    },
    ent_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__ctEnrolmentListPage", newVal.page)
          }

          this.ent_refresh = true
        }
      }
    }
  },

  computed: {
    tenant_company() {
      return this.$store.getters["organisations/organisation"].name
    },
    ent_headers: {
      get() {
        return [
          { text: this.$t("notificationtemplates.subject"), value: "subject" },
          { text: this.$t("notificationtemplates.trigger"), value: "trigger" },
          { text: this.$t("notificationtemplates.type"), value: "type" },
          { text: this.$t("coursetemplates.updated"), value: "updated_at" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    cmDragged: {
      get() {
        return this.coursetemplate_moduletemplates
      },
      set(list) {
        if (list) {
          var data = []
          var ctr = 1

          list.forEach((item, index) => {
            item.order = ctr

            data.push({ id: item.ctmt_id, order: item.order })

            ctr++
          })

          axios
            .put(this.API_URL + "coursetemplate/moduletemplateorder", {
              data: data
            })
            .then((res) => {
              this.coursetemplate_moduletemplates = list
              this.selectedModuleTemplates = this.coursetemplate_moduletemplates.map((a) => a.id)
            })
            .catch((err) => console.log(err))
        }
      }
    },
    currentLoadedForm: function () {
      let form,
        id, moduletemplate_id, moduleoption_id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        moduleoption_id = this.currentModuleOptionId
        moduletemplate_id = this.currentModuleTemplateId
        form = this.currentForm
      }

      return {
        id: id,
        form: form,
        moduletemplate_id: moduletemplate_id,
        moduleoption_id: moduleoption_id,
      }
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.coursetemplate.price)
      },
      set(val) {
        this.$set(this.coursetemplate, "price", this.$priceFormatSetter(val))
      }
    },
    computedPriceProof: {
      get() {
        return this.$priceFormatGetter(this.coursetemplate.price_proof)
      },
      set(val) {
        this.$set(this.coursetemplate, "price_proof", this.$priceFormatSetter(val))
      }
    },
    computedPriceVat: {
      get() {
        return this.$priceFormatGetter(this.coursetemplate.price_vat)
      },
      set(val) {
        this.$set(this.coursetemplate, "price_vat", this.$priceFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      let lists = [
        { key: "organisation", module: "organisation", query: "resourcetype=basic" },
        { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true" },
        { key: "moduletemplates", module: "moduletemplates", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.moduletemplates = res.data.moduletemplates
        this.organisation = res.data.organisation
        this.integrations = this.organisation.integrations

        if (this.integrations) {
          this.integration_p360 = this.integrations.find((i) => i.slug == this.INTEGRATION_SLUG_P360)
          this.integration_klarna = this.integrations.find((i) => i.slug == this.INTEGRATION_SLUG_KLARNA)
        }

        if (!this.id) {
          this.coursetemplate = {
            has_locale: false,
            status: this.$getDefaultDropdown(this.$dd_course_templates_status()),
            klarna_checkout_type: this.integration_klarna ? this.$getDefaultDropdown(this.$dd_klarna_checkout_type()) : null
          }

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.coursetemplate))

          this.setReadOnly()
          this.setPageTitle()
          this.showTypeForm = true
        } else {
          this.title = this.$t("coursetemplates.update_title")

          axios
            .get(this.API_URL + "coursetemplate/" + this.id)
            .then((res) => {
              this.coursetemplate = res.data.data
              this.coursetemplate_moduletemplates = this.coursetemplate.moduletemplates

              if (!this.organisation.sms_service) {
                this.coursetemplate.send_sms_notification = 0
              }

              if (this.integration_klarna && !this.coursetemplate.klarna_checkout_type) {
                this.coursetemplate.klarna_checkout_type = this.$getDefaultDropdown(this.$dd_klarna_checkout_type())
              }

              // JSON stringify and parse to remove variable reactiveness
              this.predata = JSON.parse(JSON.stringify(this.coursetemplate))

              this.selectedCourseTypes = this.coursetemplate.coursetypes.map((a) => a.id)
              this.selectedModuleTemplates = this.coursetemplate.moduletemplates.map((a) => a.id)

              this.setReadOnly()
              this.setPageTitle()
              this.notificationtemplate_list()

              this.courseGroupChange(this.coursetemplate.coursetypegroup_id)
            })
            .catch((err) => console.log(err))
        }
      })
    },
    setReadOnly() {
      if (this.$hasRole("system-developer")) {
        this.allow_edit = true
        this.allow_delete = true
        return
      }

      if (_.has(this.coursetemplate, "id")) {
        this.allow_edit = this.$can("coursetemplate-edit")

        this.allow_delete = this.$can("coursetemplate-delete")
      } else {
        this.allow_edit = true
        this.allow_delete = false
      }

      if (!_.has(this.coursetemplate, "id") || this.coursetemplate.coursetemplatetype_id != 0) {
        //this.$delete(this.dd_course_templates_type, 0)
      }
    },
    setPageTitle() {
      if (_.has(this.coursetemplate, "id")) {
        this.page_title = this.$t("coursetemplates.edit_coursetemplate", {
          name: this.coursetemplate.name
        })
      } else {
        this.page_title = this.$t("coursetemplates.new_coursetemplate")
      }
    },
    notificationtemplate_list() {
      this.ent_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.ent_pagination
      let query = this.$queryString(this.ent_pagination, { coursetemplate_id: this.coursetemplate.id })

      axios.get(this.API_URL + "coursetemplatenotificationtemplates?" + query).then((res) => {
        this.notificationtemplates = res.data.data
        this.ent_total = res.data.meta.total
        this.ent_refresh = false
        this.ent_show_loading = false

        this.ent_pagination.page = res.data.meta.current_page
        this.ent_pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },
    courseGroupChange(groupId) {
      axios.get(this.API_URL + "coursetypes?show_all=true&query_coursetypegroup_id=" + groupId).then((res) => {
        this.coursetypes = res.data.data

        let new_ctg = this.coursetypes.map((a) => a.id)
        _.remove(this.selectedCourseTypes, function (n) {
          return !new_ctg.includes(n)
        })

        this.$refs.coursetypegroup_id.focus()
      })
    },
    filterModuleOptions() {
      let vm = this

      if (this.coursetemplate_moduletemplates) {
        this.coursetemplate_moduletemplates.forEach(function (item) {
          item.module_options = item.module_options.filter((i) => i.coursetemplate_id == vm.coursetemplate.id)
        })
      }
    },
    preview() {
      this.$router.push(this.BACKEND_URL + "/coursetemplates/preview/" + this.id)
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.coursetemplate.id) {
              // Create
              axios
                .post(this.API_URL + "coursetemplate", {
                  name: this.coursetemplate.name,
                  internal_comment: this.coursetemplate.internal_comment,
                  short_description: this.coursetemplate.short_description,
                  long_description: this.coursetemplate.long_description,
                  certificate_display_name: this.coursetemplate.certificate_display_name,
                  coursetypegroup_id: this.coursetemplate.coursetypegroup_id,
                  coursetemplatetype_id: this.coursetemplate.coursetemplatetype_id,
                  coursetypes: this.selectedCourseTypes.join(","),
                  pdf_title: this.coursetemplate.pdf_title,
                  pdf_description: this.coursetemplate.pdf_description,
                  pdf_content: this.coursetemplate.pdf_content,
                  info_link: this.coursetemplate.info_link,
                  coursetype_id: this.coursetemplate.coursetype_id,
                  price: this.coursetemplate.price,
                  price_proof: this.coursetemplate.price_proof,
                  price_vat: this.coursetemplate.price_vat,
                  valid_for: this.coursetemplate.valid_for,
                  number_of_days: this.coursetemplate.number_of_days,
                  num_places: this.coursetemplate.num_places,
                  enrolment_due_in_days: this.coursetemplate.enrolment_due_in_days,
                  send_email_notification: this.coursetemplate.send_email_notification,
                  send_sms_notification: this.organisation.sms_service ? this.coursetemplate.send_sms_notification : 0,
                  klarna_checkout: this.integration_klarna ? this.coursetemplate.klarna_checkout : null,
                  klarna_checkout_type:
                    this.integration_klarna && this.coursetemplate.klarna_checkout ? this.coursetemplate.klarna_checkout_type : null,
                  status: this.coursetemplate.status,
                  type: this.coursetemplate.type,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.coursetemplate = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))

                      if (this.pdfTemplateFile) {
                        this.uploadTemplate()
                      }

                      vm.selectedCourseTypes = vm.coursetemplate.coursetypes.map((a) => a.id)
                      vm.selectedModuleTemplates = vm.coursetemplate.moduletemplates.map((a) => a.id)
                      vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates

                      vm.courseGroupChange(vm.coursetemplate.coursetypegroup_id)
                      vm.setPageTitle()
                      this.notificationtemplate_list()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/coursetemplates/edit/${vm.coursetemplate.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "coursetemplate", {
                  id: this.coursetemplate.id,
                  name: this.coursetemplate.name,
                  internal_comment: this.coursetemplate.internal_comment,
                  short_description: this.coursetemplate.short_description,
                  long_description: this.coursetemplate.long_description,
                  certificate_display_name: this.coursetemplate.certificate_display_name,
                  coursetypegroup_id: this.coursetemplate.coursetypegroup_id,
                  coursetemplatetype_id: this.coursetemplate.coursetemplatetype_id,
                  coursetypes: this.selectedCourseTypes.join(","),
                  pdf_title: this.coursetemplate.pdf_title,
                  pdf_description: this.coursetemplate.pdf_description,
                  pdf_content: this.coursetemplate.pdf_content,
                  info_link: this.coursetemplate.info_link,
                  coursetype_id: this.coursetemplate.coursetype_id,
                  price: this.coursetemplate.price,
                  price_proof: this.coursetemplate.price_proof,
                  price_vat: this.coursetemplate.price_vat,
                  valid_for: this.coursetemplate.valid_for,
                  number_of_days: this.coursetemplate.number_of_days,
                  num_places: this.coursetemplate.num_places,
                  enrolment_due_in_days: this.coursetemplate.enrolment_due_in_days,
                  send_email_notification: this.coursetemplate.send_email_notification,
                  send_sms_notification: this.organisation.sms_service ? this.coursetemplate.send_sms_notification : 0,
                  klarna_checkout: this.integration_klarna ? this.coursetemplate.klarna_checkout : null,
                  klarna_checkout_type:
                    this.integration_klarna && this.coursetemplate.klarna_checkout ? this.coursetemplate.klarna_checkout_type : null,
                  status: this.coursetemplate.status,
                  type: this.coursetemplate.type
                })
                .then((res) => {
                  vm.coursetemplate = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))

                  vm.selectedCourseTypes = vm.coursetemplate.coursetypes.map((a) => a.id)
                  vm.selectedModuleTemplates = vm.coursetemplate.moduletemplates.map((a) => a.id)
                  vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates

                  vm.setPageTitle()
                  vm.notificationtemplate_list()
                  vm.courseGroupChange(vm.coursetemplate.coursetypegroup_id)

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetemplates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    delModuleTemplate(cid, mid) {
      let vm = this
      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/" + cid + "/moduletemplate/" + mid)
            .then((res) => {
              vm.coursetemplate = res.data.data
              vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
              vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates
              vm.selectedCourseTypes = vm.coursetemplate.coursetypes.map((a) => a.id)
              vm.selectedModuleTemplates = vm.coursetemplate.moduletemplates.map((a) => a.id)
              vm.courseGroupChange(vm.coursetemplate.coursetypegroup_id)
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option_ct(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoptioncoursetype/" + id)
            .then((res) => {
              vm.loadModuleTemplates()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    duplicate() {
      let vm = this

      this.$awn.confirm(
        this.$t("coursetemplates.duplicate_message"),
        () => {
          axios
            .post(this.API_URL + "coursetemplate/duplicate/" + this.coursetemplate.id)
            .then((res) => {
              let coursetemplate = res.data.data

              if (coursetemplate) {
                vm.$router.push(this.BACKEND_URL + "/coursetemplates/edit/" + coursetemplate.id)
                vm.init()
                vm.$awn.success(vm.$t("global.create_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },
    modtemplistpopup_show() {
      this.showModuleTemplateListPopup = true
    },
    callback_modtemplistpopup_submit(data) {
      this.callback_modtemplistpopup_cancel()

      let ids = data.map((i) => i.id)
      let mt_ids = [...this.selectedModuleTemplates, ...ids]
      if (mt_ids) {
        axios
          .put(this.API_URL + "coursetemplate/moduletemplate", {
            id: this.coursetemplate.id,
            moduletemplates: mt_ids.join(",")
          })
          .then((res) => {
            let coursetemplate = res.data.data
            this.selectedModuleTemplates = coursetemplate.moduletemplates.map((a) => a.id)
            this.coursetemplate_moduletemplates = coursetemplate.moduletemplates
          })
          .catch((err) => console.log(err))
      }
    },
    callback_modtemplistpopup_cancel() {
      this.showModuleTemplateListPopup = false
    },

    showUploadTemplate() {
      this.showUploadTemplateForm = true
    },

    cancelUploadTemplate() {
      this.showUploadTemplateForm = false
      this.pdfTemplateFile = null
    },

    async uploadTemplate() {
      let vm = this
      let formData = new FormData()

      if(this.$refs.pdfTemplateFile) {
        const isValid = await this.$refs.pdfTemplateFile.validate()
        if (!isValid) {
          return
        }
      }

      if (this.coursetemplate.id) {
        formData.append("id", this.coursetemplate.id)
        formData.append("pdf_template_file", this.pdfTemplateFile)

        axios
          .post(this.API_URL + "coursetemplate/template/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            vm.pdfTemplateFile = null

            vm.coursetemplate.filename = res.data.data.filename
            vm.coursetemplate.original_filename = res.data.data.original_filename

            vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
            vm.cancelUploadTemplate()
          })
          .catch((err) => console.log(err))
      } else {
        this.showUploadTemplateForm = false
      }
    },

    downloadTemplate(filename, original_filename) {
      axios({
        url: this.API_URL + "s3/download?file=" + filename,
        method: "GET",
        responseType: "arraybuffer"
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", original_filename)
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },

    deleteTemplate(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/template/delete/" + id)
            .then((res) => {
              vm.coursetemplate.filename = res.data.data.filename
              vm.coursetemplate.original_filename = res.data.data.original_filename

              vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))

              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    async documentOnDrop(e) {
      this.document_dragover = false
      let valid_ext = ["pdf"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.pdfTemplateFile = file
          }
        }
      }

      if(this.$refs.pdfTemplateFile) {
        await this.$refs.pdfTemplateFile.validate()
      }      
    },

    previewTemplate(id) {
      axios({
        url: this.API_URL + "coursetemplate/template/preview",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: id
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", "preview.pdf")
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },

    updateModuleTemplateHideAcc(id, event, updateHideEnr = false) {
      let vm = this

      axios
        .put(this.API_URL + "moduletemplate/updatefield", {
          id: id,
          field: "hide_in_accomplishment",
          value: event ? 1 : 0
        })
        .then((res) => {
          if (updateHideEnr && event) {
            var idx = vm.coursetemplate_moduletemplates.findIndex((i) => i.id == id)
            if (idx !== -1) {
              vm.$set(vm.coursetemplate_moduletemplates[idx], "hide_in_enrolment", 0)
            }

            vm.updateModuleTemplateHideEnr(id, !event)
          } else {
            vm.$awn.success(vm.$t("global.update_success"))
          }

          vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
        })
        .catch((err) => console.log(err))
    },
    updateModuleTemplateHideEnr(id, event, updateHideAcc = true) {
      let vm = this

      axios
        .put(this.API_URL + "moduletemplate/updatefield", {
          id: id,
          field: "hide_in_enrolment",
          value: event ? 1 : 0
        })
        .then((res) => {
          if (updateHideAcc && event) {
            var idx = vm.coursetemplate_moduletemplates.findIndex((i) => i.id == id)
            if (idx !== -1) {
              vm.$set(vm.coursetemplate_moduletemplates[idx], "hide_in_accomplishment", 0)
            }

            vm.updateModuleTemplateHideAcc(id, !event)
          } else {
            vm.$awn.success(vm.$t("global.update_success"))
          }

          vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
        })
        .catch((err) => console.log(err))
    },
    updateSingleField(id, field, value) {
      let vm = this

      axios
        .put(this.API_URL + "moduletemplate/updatefield", {
          id: id,
          field: field,
          value: value
        })
        .then((res) => {
          vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
        })
        .catch((err) => console.log(err))
    },

    editModuleTemplate(mid) {
      this.showCourseTemplateListPopup = true
      this.selectedModuleTemplate = mid
    },
    callback_coursetemplistpopup_cancel() {
      this.selectedModuleTemplate = null
      this.showCourseTemplateListPopup = false
    },
    callback_coursetemplistpopup_submit(data) {
      let id = JSON.parse(JSON.stringify(this.selectedModuleTemplate))
      this.showForm(id, "moduletemplate")
      this.showCourseTemplateListPopup = false
    },

    showForm(id, type, mid) {
      this.currentFormId = id

      if (type == "moduleoption") this.currentModuleTemplateId = mid
      if (type == "moduleoptioncoursetype") this.currentModuleOptionId = mid

      this.currentForm = type + "-form"
    },
    loadModuleTemplates() {
      // Refresh module templates
      axios.get(this.API_URL + "coursetemplate/" + this.id).then((res) => {
        this.coursetemplate_moduletemplates = res.data.data.moduletemplates
        this.selectedModuleTemplates = this.coursetemplate.moduletemplates.map((a) => a.id)
      })
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.loadModuleTemplates()
    },
    return_modal_cancel_form() {
      this.currentFormId = null
      this.currentForm = null
      this.showDialogForm = false
    },
    selectTemplateType(type) {
      this.coursetemplate.type = type
      this.predata = JSON.parse(JSON.stringify(this.coursetemplate))
      this.showTypeForm = false
    },
    cancelTypeSelection() {
      this.showTypeForm = false
      this.$router.push(this.BACKEND_URL + "/coursetemplates")
    },
    redirectToInfoLink() {
      if (this.coursetemplate.info_link) {
        window.open(this.$getValidUrl(this.coursetemplate.info_link), "_blank")
      }
    },
    copyInfoLink() {
      var copyText = document.getElementById("copy-info-link")
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value)

      this.showInfoLinkCopiedToolTip = true
      setTimeout(() => {
        this.showInfoLinkCopiedToolTip = false
      }, 1000)
    }
  }
}
</script>

<style>
.v-text-field__suffix {
  font-size: 12px;
  color: var(--v-accent-lighten1) !important;
}
.mt-chkbox {
  margin-top: 18px !important;
  margin-right: 30px !important;
}
.mt-chkbox .v-input__slot {
  margin-bottom: 0 !important;
}
.drag-icon:hover {
  cursor: pointer;
}
</style>
